import { inject, Service } from "@angular/core";

import { ActivityDs3Model, MainResponseModel } from "../models";
import { MainService } from "./main-service";

@Service()
export class ProjectActivityApiService {
  private _mainService = inject(MainService);

  public getById(id: number) {
    return this._mainService.sendRequest<MainResponseModel<ActivityDs3Model>>({
      method: "GET",
      url: `project-activity/getById/${id}`,
    });
  }

  public saveActivity(data: Record<string, unknown>) {
    return this._mainService.sendRequest<MainResponseModel>({
      method: "POST",
      url: `project-activity/update?isFinish=true`,
      data: data,
    });
  }
}
